import {isDraft} from '@wix/wix-events-commons-statics'
import {isPreview, isSite} from '../../../../commons/selectors/environment'
import {isTemplate} from '../../../../commons/selectors/instance'
import {State} from '../types/state'
import {getEvent} from './event'
import {isEventPreview} from './navigation'

export const isCheckoutVisibilityEnabled = (state: State) =>
  isSite(state) && !isPreview(state) && !isTemplate(state) && !isEventPreview(state) && !isDraft(getEvent(state))
